import { TABLE, TABLE_CELL, TABLE_HEAD, TableCard } from './TableCard';
import { useLanguage } from '../../contexts/LanguageContext';

// THE PARTS TABLE BEFORE THERE ARE PARTS: its rows, each with an empty cell, so the phase shows
// what the first press will fill rather than a sentence saying it has not been pressed. The
// rows every manual answers; the ones only some manuals print (a reference, a bag) appear with
// the list, as they do in the real table (PartsTable).
const ROWS = [
  'notice.parts.category', 'notice.parts.name', 'notice.parts.description', 'notice.parts.qty',
  'notice.parts.letter', 'notice.parts.size',
];

export function EmptyPartsTable() {
  const { t } = useLanguage();
  return (
    <TableCard title={t('notice.parts.tableTitle')} className="max-w-5xl">
      <table className={TABLE}>
        <tbody>
          {ROWS.map((k) => (
            <tr key={k}>
              <th className={`w-40 ${TABLE_HEAD}`}>{t(k)}</th>
              <td className={`min-w-[8rem] ${TABLE_CELL}`}>{' '}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableCard>
  );
}
